<script lang="ts">
  import Block from "$lib/components/blocks/Block.svelte"
  import BlockHero from "$lib/components/blocks/BlockHero.svelte"

  export let data

  const { hasPremiumSubscription, featuredMedia, blocks } = data
  const canWatch = hasPremiumSubscription || !featuredMedia.subscriptionRequired
  const buttonTitle = canWatch ? "Watch now" : "Subscribe to watch"
  const buttonUrl = canWatch ? `/video/${featuredMedia.slug}` : "/subscription/plan?next=/videos"
</script>

<div>
  <BlockHero
    title={featuredMedia.title}
    content={featuredMedia.descriptionText}
    {buttonTitle}
    {buttonUrl}
    backgroundImage={featuredMedia.poster || featuredMedia.thumbnail}
    countdownDate={featuredMedia.dateStart || null}
    socialIcons={false}
  />

  <!-- Blocks -->
  <div class="flex flex-col gap-10">
    {#each blocks as block, index}
      <Block type={block.collection} data={block.data} aboveFold={index <= 1} />
    {/each}
  </div>

  <!-- Bottom decoraton -->
  <div class="pb-18 relative mt-12">
    <div class="bg-striped-sm-2 absolute bottom-0 left-0 right-0 h-32"></div>
  </div>
</div>
